var _rect, _line, _text, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _circle, _circle2, _circle3, _path, _line2, _circle4, _circle5, _path2, _line3, _circle6, _circle7, _line4, _path3, _path4, _line5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutHero(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 200",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 38,
    width: 120,
    height: 148,
    rx: 4,
    fill: "rgba(255,255,255,0.1)",
    stroke: "rgba(255,255,255,0.75)",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 56,
    x2: 200,
    y2: 56,
    stroke: "rgba(255,255,255,0.35)",
    strokeWidth: 1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 140,
    y: 50,
    textAnchor: "middle",
    fontFamily: "system-ui,sans-serif",
    fontSize: 7,
    fill: "rgba(255,255,255,0.65)",
    fontWeight: 700,
    letterSpacing: 1.5
  }, "DOMMICRO")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 62,
    width: 20,
    height: 16,
    rx: 2,
    fill: "rgba(255,255,255,0.35)",
    stroke: "rgba(255,255,255,0.5)",
    strokeWidth: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 62,
    width: 20,
    height: 16,
    rx: 2,
    fill: "rgba(255,255,255,0.18)",
    stroke: "rgba(255,255,255,0.5)",
    strokeWidth: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 62,
    width: 20,
    height: 16,
    rx: 2,
    fill: "rgba(255,255,255,0.4)",
    stroke: "rgba(255,255,255,0.5)",
    strokeWidth: 1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 62,
    width: 20,
    height: 16,
    rx: 2,
    fill: "rgba(255,255,255,0.2)",
    stroke: "rgba(255,255,255,0.5)",
    strokeWidth: 1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 86,
    width: 20,
    height: 16,
    rx: 2,
    fill: "rgba(255,255,255,0.2)",
    stroke: "rgba(255,255,255,0.5)",
    strokeWidth: 1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 86,
    width: 20,
    height: 16,
    rx: 2,
    fill: "rgba(255,255,255,0.4)",
    stroke: "rgba(255,255,255,0.5)",
    strokeWidth: 1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 86,
    width: 20,
    height: 16,
    rx: 2,
    fill: "rgba(255,255,255,0.18)",
    stroke: "rgba(255,255,255,0.5)",
    strokeWidth: 1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 86,
    width: 20,
    height: 16,
    rx: 2,
    fill: "rgba(255,255,255,0.38)",
    stroke: "rgba(255,255,255,0.5)",
    strokeWidth: 1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 110,
    width: 20,
    height: 16,
    rx: 2,
    fill: "rgba(255,255,255,0.38)",
    stroke: "rgba(255,255,255,0.5)",
    strokeWidth: 1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 110,
    width: 20,
    height: 16,
    rx: 2,
    fill: "rgba(255,255,255,0.18)",
    stroke: "rgba(255,255,255,0.5)",
    strokeWidth: 1
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 110,
    width: 20,
    height: 16,
    rx: 2,
    fill: "rgba(255,255,255,0.35)",
    stroke: "rgba(255,255,255,0.5)",
    strokeWidth: 1
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 110,
    width: 20,
    height: 16,
    rx: 2,
    fill: "rgba(255,255,255,0.18)",
    stroke: "rgba(255,255,255,0.5)",
    strokeWidth: 1
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 153,
    width: 30,
    height: 33,
    rx: 2,
    fill: "rgba(255,255,255,0.12)",
    stroke: "rgba(255,255,255,0.6)",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 149,
    cy: 170,
    r: 2,
    fill: "rgba(255,255,255,0.7)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 100,
    r: 18,
    fill: "rgba(255,255,255,0.09)",
    stroke: "rgba(255,255,255,0.55)",
    strokeWidth: 1.5,
    strokeDasharray: "4 3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 94,
    r: 5.5,
    fill: "rgba(255,255,255,0.65)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 110 Q20 103 32 103 Q44 103 44 110",
    fill: "rgba(255,255,255,0.45)",
    stroke: "none"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 100,
    x2: 80,
    y2: 100,
    stroke: "rgba(255,255,255,0.4)",
    strokeWidth: 1.5,
    strokeDasharray: "5 4"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 288,
    cy: 100,
    r: 18,
    fill: "rgba(255,255,255,0.09)",
    stroke: "rgba(255,255,255,0.55)",
    strokeWidth: 1.5,
    strokeDasharray: "4 3"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 288,
    cy: 94,
    r: 5.5,
    fill: "rgba(255,255,255,0.65)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M276 110 Q276 103 288 103 Q300 103 300 110",
    fill: "rgba(255,255,255,0.45)",
    stroke: "none"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 100,
    x2: 270,
    y2: 100,
    stroke: "rgba(255,255,255,0.4)",
    strokeWidth: 1.5,
    strokeDasharray: "5 4"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 15,
    r: 14,
    fill: "rgba(255,255,255,0.09)",
    stroke: "rgba(255,255,255,0.55)",
    strokeWidth: 1.5,
    strokeDasharray: "4 3"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 15,
    r: 5.5,
    fill: "none",
    stroke: "rgba(255,255,255,0.7)",
    strokeWidth: 1.2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 134.5,
    y1: 15,
    x2: 145.5,
    y2: 15,
    stroke: "rgba(255,255,255,0.7)",
    strokeWidth: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M137.5 9.5 Q140 15 137.5 20.5",
    fill: "none",
    stroke: "rgba(255,255,255,0.7)",
    strokeWidth: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M142.5 9.5 Q140 15 142.5 20.5",
    fill: "none",
    stroke: "rgba(255,255,255,0.7)",
    strokeWidth: 1
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 29,
    x2: 140,
    y2: 38,
    stroke: "rgba(255,255,255,0.4)",
    strokeWidth: 1.5,
    strokeDasharray: "4 3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutHero);
export default __webpack_public_path__ + "static/media/about_hero.b4c081fafc6ad0869c32fe3752a480b8.svg";
export { ForwardRef as ReactComponent };